import { api } from "./api";

export async function unpublishCv(
  id: string,
): Promise<{ id: string; isPublic: false }> {
  const result = await api.post<{ id: string; isPublic: false }>(
    `/api/cv/${encodeURIComponent(id)}/unpublish`,
    {},
  );
  if (result.error || !result.data)
    throw new Error(result.error?.message || "Could not turn off public page");
  return result.data;
}
